import { Component, Input } from '@angular/core';
import { Member } from '@app/models/member';

@Component({
  selector: 'app-memberdetails',
  templateUrl: './memberdetails.component.html'
})
export class MemberdetailsComponent  {
  @Input() member: Member;

  constructor() { }



}
